import { z } from 'zod'

export const COACHING_SHELL_COMPANY_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellCompanyResponseSchema = z.unknown()
export type CoachingShellCompanyResponse = z.infer<typeof coachingShellCompanyResponseSchema>
